import React from "react";

export const ChristmasIcon = ({size = 20, ...props}) => {
	return (
		<svg
			viewBox="0 0 512 512"
			height={size}
			width={size}
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M363.125 376.999c-22.421 0-40.596 3.265-40.596 32.444 0 29.178 18.175 52.832 40.596 52.832s40.596-23.654 40.596-52.832c0-29.179-18.176-32.444-40.596-32.444zM65.97 376.999c22.421 0 40.596 3.265 40.596 32.444 0 29.178-18.175 52.832-40.596 52.832s-40.596-23.654-40.596-52.832c0-29.179 18.176-32.444 40.596-32.444z"
				fill="#c42430"
			/>
			<path
				d="M303.93 104.088H125.165c-23.741 49.884-67.302 194.792 9.216 257.557h160.334c76.517-62.765 32.956-207.673 9.215-257.557z"
				fill="#655e67"
			/>
			<path
				d="M303.93 104.088h-27.461c24.106 57.29 60.335 195.898-12.634 257.557h30.879c76.517-62.765 32.957-207.673 9.216-257.557z"
				fill="#544f56"
			/>
			<path
				d="M236.332 134.086c-16.324 24.325-56.461 49.026-86.348 58.111a15.745 15.745 0 00-11.184 15.065v24.524c0 41.834 33.913 75.748 75.748 75.748s75.748-33.913 75.748-75.748v-97.699h-53.964z"
				fill="#ffcdbe"
			/>
			<path
				d="M119.846 321.469c0 13.241 9.497 24.553 22.526 26.909a405.706 405.706 0 00144.352 0c13.029-2.356 22.526-13.668 22.526-26.909 0-16.722-14.901-29.626-31.418-27.017a405.665 405.665 0 01-126.567 0c-16.518-2.609-31.419 10.295-31.419 27.017z"
				fill="#6cbff8"
			/>
			<path
				d="M277.831 294.452a406.101 406.101 0 01-15.38 2.125c10.039 4.464 17.221 14.557 17.221 26.498 0 14.018-10.054 25.995-23.848 28.489a428.575 428.575 0 01-15.152 2.434 405.53 405.53 0 0046.052-5.62c13.029-2.356 22.526-13.669 22.526-26.909-.001-16.722-14.902-29.626-31.419-27.017z"
				fill="#5fa7ee"
			/>
			<circle cx={214.547} cy={25.041} fill="#cbe5e8" r={25.041} />
			<path
				d="M322.247 140.464c.331-3.22.506-6.482.506-9.784 0-55.834-69.985-94.047-108.205-94.047-38.221 0-108.206 38.213-108.206 94.047 0 3.301.175 6.564.506 9.784z"
				fill="#fd4755"
			/>
			<path
				d="M214.548 36.633c-3.591 0-7.462.338-11.529.995 31.671 6.34 78.061 42.463 78.061 93.052 0 3.301-.141 6.564-.409 9.784h41.576c.331-3.22.506-6.482.506-9.784 0-55.834-69.985-94.047-108.205-94.047z"
				fill="#c42430"
			/>
			<path
				d="M326.588 170.835c-72.658-23.003-151.424-23.003-224.081 0-8.194 2.594-16.537-3.571-16.537-12.167v-8.308c0-14.353 9.45-26.993 23.214-31.064 68.558-20.278 142.171-20.278 210.729 0 13.764 4.071 23.214 16.711 23.214 31.064v8.308c-.002 8.596-8.344 14.761-16.539 12.167z"
				fill="#faf7f7"
			/>
			<path
				d="M319.912 119.297a367.649 367.649 0 00-18.851-5.031c11.043 6.038 18.206 17.69 18.206 30.66v8.969c0 5.652-3.349 10.316-7.961 12.478 5.12 1.38 10.218 2.86 15.283 4.464 8.194 2.594 16.537-3.571 16.537-12.167v-8.308c-.001-14.354-9.451-26.994-23.214-31.065z"
				fill="#cbe5e8"
			/>
			<g fill="#cbe5e8">
				<path d="M137.272 156.372v-13.074c0-11.429 1.706-22.39 4.803-30.864.157-.431.266-.867.344-1.304a370.28 370.28 0 00-17.258 3.844c-2.173 8.559-3.342 18.341-3.342 28.324v13.074c0 3.008.262 5.961.729 8.743a369.875 369.875 0 0115.085-3.514 38.314 38.314 0 01-.361-5.229zM241.686 154.579c5.146.375 10.286.847 15.415 1.435.056-1.331.062-3.087.07-5.533a437.97 437.97 0 00-.213-14.914c-.378-11.915-1.202-21.739-2.456-29.336a373.336 373.336 0 00-15.978-1.359c3.243 14.905 3.306 42.353 3.162 49.707zM291.462 161.602a368.171 368.171 0 0115.084 3.514 53.07 53.07 0 00.729-8.743v-13.074c0-9.983-1.17-19.764-3.342-28.324a369.709 369.709 0 00-17.258-3.844c.078.437.187.873.344 1.304 3.097 8.474 4.803 19.435 4.803 30.864v13.074a38.18 38.18 0 01-.36 5.229zM174.542 106.237c-2.633 15.98-2.563 37.825-2.531 47.898v1.877a373.81 373.81 0 0115.451-1.437v-.49c-.031-9.688-.11-34.859 3.062-49.211-5.336.345-10.665.79-15.982 1.363z" />
			</g>
			<path
				d="M214.547 512L85.025 483.875a11.048 11.048 0 01-8.704-10.797V329.963c0-7.046 6.507-12.292 13.393-10.797l124.834 27.107V512z"
				fill="#faf7f7"
			/>
			<path
				d="M172.35 390.793a7.687 7.687 0 01-1.647-.178l-50.801-11.032c-4.17-.905-6.816-5.02-5.91-9.19s5.022-6.819 9.19-5.91l50.801 11.032a7.725 7.725 0 015.91 9.19 7.73 7.73 0 01-7.543 6.088zM172.35 442.43a7.694 7.694 0 01-1.647-.178l-50.801-11.031c-4.17-.905-6.816-5.02-5.91-9.19s5.014-6.816 9.19-5.911l50.801 11.031a7.725 7.725 0 015.91 9.19 7.73 7.73 0 01-7.543 6.089z"
				fill="#655e67"
			/>
			<path
				d="M214.547 512l129.523-28.125a11.048 11.048 0 008.704-10.797V329.963c0-7.046-6.507-12.292-13.393-10.797l-124.834 27.107z"
				fill="#cbe5e8"
			/>
			<path
				d="M352.774 329.963c0-7.046-6.507-12.292-13.393-10.797l-12.859 2.792c6.92 42.806 13.594 126.778-10.706 168.052l28.254-6.135a11.048 11.048 0 008.704-10.797z"
				fill="#a8d3d8"
			/>
			<path
				d="M365.513 427.763h-12.286c-8.885 0-16.088-7.203-16.088-16.088v-38.977c0-8.885 7.203-16.088 16.088-16.088h12.286c12.042 0 22.756 7.934 25.974 19.538 2.965 10.692 2.965 21.385 0 32.077-3.217 11.605-13.932 19.538-25.974 19.538zM63.581 427.763h12.286c8.885 0 16.088-7.203 16.088-16.088v-38.977c0-8.885-7.203-16.088-16.088-16.088H63.581c-12.042 0-22.756 7.934-25.974 19.538-2.965 10.692-2.965 21.385 0 32.077 3.218 11.605 13.933 19.538 25.974 19.538z"
				fill="#fd4755"
			/>
			<path
				d="M483.787 93.375a6.693 6.693 0 00-6.111-.831l-67.24 24.032a6.696 6.696 0 00-4.443 6.305v50.093a23.718 23.718 0 00-10.474-2.427c-13.159 0-23.865 10.706-23.865 23.866s10.706 23.866 23.865 23.866c13.16 0 23.866-10.706 23.866-23.866v-66.814l53.848-19.245v40.589a23.718 23.718 0 00-10.474-2.427c-13.159 0-23.865 10.706-23.865 23.866s10.706 23.866 23.865 23.866c13.16 0 23.866-10.706 23.866-23.866V98.849a6.695 6.695 0 00-2.838-5.474z"
				fill="#655e67"
			/>
			<g fill="#444145">
				<path d="M183.549 221.489a7.725 7.725 0 01-7.726-7.726v-3.606a7.726 7.726 0 1115.452 0v3.606a7.725 7.725 0 01-7.726 7.726zM245.545 221.489a7.725 7.725 0 01-7.726-7.726v-3.606a7.726 7.726 0 1115.452 0v3.606a7.725 7.725 0 01-7.726 7.726z" />
			</g>
			<path
				d="M236.967 249.365c0 12.382-10.038 22.419-22.419 22.419s-22.419-10.038-22.419-22.419 10.036-7.201 22.418-7.201c12.381.001 22.42-5.181 22.42 7.201z"
				fill="#d97b7b"
			/>
		</svg>
	);
}

export default ChristmasIcon;
